import type { HTMLAttributes } from 'react'

export type MapMarkerStatus = 'inactive' | 'active'

interface MapMarkerProps extends HTMLAttributes<HTMLDivElement> {
	/** Count shown in the marker (matching available units). */
	value: number | string
	status?: MapMarkerStatus
}

const statusClasses: Record<MapMarkerStatus, string> = {
	inactive: 'spaces:bg-brand-base spaces:text-brand-on-base spaces:hover:bg-brand-hover',
	active: 'spaces:bg-canvas-inverse spaces:text-content-inverse'
}

/**
 * Count pin for the portfolio map. Presentational only — the map marker
 * wrapping it owns click and keyboard handling.
 */
export function MapMarker ({ value, status = 'inactive', className = '', ...rest }: MapMarkerProps) {
	const classes = [
		'spaces-map-marker spaces:flex spaces:items-center spaces:justify-center spaces:min-w-32 spaces:p-6 spaces:border-2 spaces:border-white spaces:rounded-full spaces:shadow-sm-below spaces:transition-colors spaces:cursor-pointer',
		'spaces:text-14/16 spaces:font-strong spaces:text-center spaces:whitespace-nowrap',
		statusClasses[status],
		className
	].join(' ')

	return (
		<div className={classes} data-status={status} aria-hidden {...rest}>
			{value}
		</div>
	)
}
